import { render, staticRenderFns } from "./SafetyObservationReport.vue?vue&type=template&id=dfdb7b4a&"
import script from "./SafetyObservationReport.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationReport.vue?vue&type=script&lang=js&"
import style0 from "./SafetyObservationReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports